// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-vue[data-v-50f61f8e]{margin-top:.5rem}`, "",{"version":3,"sources":["webpack://./core/src/components/login/LoginButton.vue"],"names":[],"mappings":"AACA,6BACC,gBAAA","sourcesContent":["\n.button-vue {\n\tmargin-top: .5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
